import { Button } from "@mui/material";

import React from "react";

import I18nLink from "../../../../components/Atoms/I18nLink";

type Props = {
    href: string;
    title: string;
    direction: "left" | "right";
};

const ArticleButton = ({ href, title, direction }: Props) => {
    const isLeft = direction === "left";

    return (
        <Button
            href={href}
            component={I18nLink}
            variant="outlined"
            size="large"
            fullWidth
            sx={{
                marginRight: isLeft ? 1 : 0,
                marginLeft: isLeft ? 0 : 1,
                borderColor: (theme) => theme.palette.primary.main,
                borderLeftWidth: isLeft ? 8 : 1,
                borderRightWidth: isLeft ? 1 : 8,
                "&:hover": {
                    borderLeftWidth: isLeft ? 8 : 1,
                    borderRightWidth: isLeft ? 1 : 8
                }
            }}
        >
            {title}
        </Button>
    );
};

export default ArticleButton;
